<template>
    <!-- Footer START -->
    <footer class="pt-3 bg-mode" style="margin-top: 250px;">
        <div class="container ">
            <div class="row g-">
                <div class="col-sm-12 col-lg-12">
                    <!-- Footer Widget -->
                    <ul class="nav flex-column">
                        <li class="nav-item"><a class="nav-link" href="https://zadcodeonline.com/ahmad/etqan/itqan_app.apk" target="_blank"> <i class="bi bi-phone fa-fw pe-2"></i> حمل
                                تطبيقنا</a></li>
                        <li class="nav-item"><router-link class="nav-link pt-0" to="/privacy-policy"> سياسة الخصوصية
                            </router-link></li>
                        <li class="nav-item"><router-link class="nav-link pt-0" to="/how-we"> من نحن </router-link></li>
                        <li class="nav-item"><a class="nav-link" href="#"> الدعم </a></li>
                    </ul>
                </div>
            </div>
        </div>
        <hr class="mb-0 mt-2">
        <div class="bg- light py-3">
            <div class="container">
                <div class="row">
                    <div class="col-lg-12">
                        <!-- Copyright START -->
                        <p class="text-center mb-0">©2025 <a class="text-body" target="_blank" href="#"></a>جميع الحقوق محفوظة لصالح منصة إتقان.</p>
                        <!-- Copyright END -->
                    </div>
                </div>
            </div>
        </div>
    </footer>
    <!-- Footer END -->
</template>


<script>
export default {
    name: "FooterComponent",
};
</script>


<style scoped>
.nav-link {
    color: #ffffff;
}

footer {
    bottom: 0;
    left: 0;
    width: 100%;
    color: #fff;
    background-color: #296080;
    padding: 20px;
    text-align: center;
}

.card-header {
    border-radius: 30px;
}

h3 {
    margin: 40px 0 0;
}

ul {
    list-style-type: none;
    padding: 0;
}

li {
    display: inline-block;
    margin: 0 10px;
}


.text-itkan {
    font-size: 25px;
    color: #ffffff;
}

.text-person {
    color: #296080;
}

.text-date {
    font-size: 10px;
}

.rounded-card {
    border-radius: 25px;
    overflow: hidden;
}

.carousel-item img {
    border-radius: 30px;
    height: 200px;
    object-fit: cover;
}

@media (max-width: 576px) {
    .carousel-item img {
        border-radius: 30px;
        height: 200px;
        object-fit: cover;
    }
}



@media (max-width: 768px) {


    .navbar>.container,
    .navbar>.container-fluid,
    .navbar>.container-sm,
    .navbar>.container-md,
    .navbar>.container-lg,
    .navbar>.container-xl,
    .navbar>.container-xxl {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -ms-flex-wrap: inherit;
        flex-wrap: inherit;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        -webkit-box-pack: justify;
        -ms-flex-pack: justify;
        justify-content: space-between;
        flex-direction: row-reverse;
    }
}
</style>